import apiClient from './api.service';
import {
  ParticipantProfile,
  CreateProfileData,
  UpdateProfileData,
  State,
  City,
} from '../types/profile.types';

// Phase 3 - US1: Profile Service
// T049: Frontend profile API wrapper

export interface Country {
  id: string;
  name: string;
  code: string;
}

class ProfileService {
  async createProfile(data: CreateProfileData): Promise<ParticipantProfile> {
    const response = await apiClient.post<{ data: ParticipantProfile }>(
      '/api/profiles',
      data
    );
    return response.data.data;
  }

  async getProfile(): Promise<ParticipantProfile> {
    const response = await apiClient.get<{ data: ParticipantProfile }>(
      '/api/profiles'
    );
    return response.data.data;
  }

  async updateProfile(data: UpdateProfileData): Promise<ParticipantProfile> {
    const response = await apiClient.put<{ data: ParticipantProfile }>(
      '/api/profiles',
      data
    );
    return response.data.data;
  }

  async getCountries(search?: string): Promise<Country[]> {
    const params = new URLSearchParams();
    if (search && search.length >= 2) {
      params.append('search', search);
    }
    params.append('limit', '20');

    const response = await apiClient.get<{ data: Country[] }>(
      `/api/geo/countries?${params.toString()}`
    );
    return response.data.data;
  }

  async getStatesByCountry(countryId: string, search?: string): Promise<State[]> {
    const params = new URLSearchParams();
    if (search && search.length >= 2) {
      params.append('search', search);
    }
    params.append('limit', '20');

    const response = await apiClient.get<{ data: State[] }>(
      `/api/geo/countries/${countryId}/states?${params.toString()}`
    );
    return response.data.data;
  }

  async getStates(): Promise<State[]> {
    const response = await apiClient.get<{ data: State[] }>('/api/geo/states');
    return response.data.data;
  }

  async getCitiesByState(stateId: string, search?: string): Promise<City[]> {
    const params = new URLSearchParams();
    if (search && search.length >= 2) {
      params.append('search', search);
    }
    params.append('limit', '20');

    const response = await apiClient.get<{ data: City[] }>(
      `/api/geo/states/${stateId}/cities?${params.toString()}`
    );
    return response.data.data;
  }

  async getCityById(cityId: string): Promise<City> {
    const response = await apiClient.get<{ data: City }>(
      `/api/geo/cities/${cityId}`
    );
    return response.data.data;
  }
}

export const profileService = new ProfileService();
